<img class="icon-close" (click)="onCloseClick()" src="../../../assets/icons/ico-close.png" alt="close icon">

<div class="mt-3">
    <h1 mat-dialog-title class="mb-3"> {{ data.title }} </h1>

    <mat-dialog-content>
        {{ data.description }}
        {{ data.question }} 
    </mat-dialog-content>

    <mat-dialog-actions>
        <button (click)="onSecondaryActionClick()" class="btn-secondary-tbk mx-auto">{{ data.actions.secondary}}</button>
        <button (click)="onPrimaryActionClick()" class="btn-primary-tbk mx-auto">{{ data.actions.primary }}</button>
    </mat-dialog-actions>
</div>